import React, { createContext } from 'react';

import { SessionExpiredModal } from '@/components/Modals';

import { useSessionExpiredContext } from './useSessionExpiredContext';

export interface SessionExpiredContextValue {
  allowPath: Nullable<string>;
}

export const SessionExpiredContext = createContext<SessionExpiredContextValue>({ allowPath: null });

export const SessionExpiredProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { allowPath, isModalOpen, onLogin, onStay } = useSessionExpiredContext();

  return (
    <SessionExpiredContext.Provider value={{ allowPath }}>
      {children}
      <SessionExpiredModal open={isModalOpen} onLogin={onLogin} onStay={onStay} />
    </SessionExpiredContext.Provider>
  );
};
